import { useState, useEffect, useMemo, useRef, useCallback } from 'react'
import SearchApi from 'js-worker-search'

// Custom hook that abstracts away some search logic
export function useSearch(onChange) {
  const [query, setQuery] = useState('')

  // Wrapping onToggle in a ref allows the user of this hook to change the onToggle
  // without causing the toggleById functions to change.
  const onChangeRef = useRef
  onChangeRef.current = onChange

  // Keep a not changing reference to the search api instance
  const searchApi = useMemo(() => new SearchApi(), [])

  useEffect(() => {
    return () => {
      // Frees the resources the browsers uses for the web worker that the searchApi uses.
      // Because the searchApi won't change this will only be executed when the user component un-mounts.
      searchApi.terminate()
    }
  }, [searchApi])

  const onQueryChange = useCallback(
    function handleSearch(event) {
      // The value the user typed
      const query = event.target.value

      if (onChangeRef.current) {
        onChangeRef.current(query)
      }

      // Set the query immediately so the UI is responsive to the user typing.
      setQuery(query)
    },
    [onChangeRef]
  )

  return {
    query,
    search: searchApi.search,
    indexDocument: searchApi.indexDocument,
    onQueryChange,
  }
}
